import { axios } from 'libs/axios';

import { IUser } from '../types';

export const getUser = (): Promise<IUser> => {
	return axios.get(`/auth/me/`);
};
